<script lang="ts">
  interface Props {
    plan: PlanType
    meeting: MeetingType
    onboarding: OnboardingType
    update_core: boolean
  }

  let props = $props()

  let { plan, meeting, onboarding, update_core = false }: Props = props
</script>

{#if onboarding.completed_onboarding && update_core && meeting.banner_enabled && meeting}
  <div class="relative {meeting.quarter === 1 ? 'bg-red-50' : 'bg-green-50'}">
    <div class="max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8">
      <div class="pr-16 text-center sm:px-16">
        <p
          class="font-normal {meeting.quarter === 1
            ? 'text-red-700'
            : 'text-green-700'}"
        >
          <span class="inline">
            Q{meeting.quarter}
            {meeting.fiscal_year}
            {#if meeting.quarter_started}
              has already started!
            {:else}
              is coming up!
            {/if}
          </span>
          <span class="block sm:ml-2 sm:inline-block">
            <a
              href="/plans/{plan.id}/meetings/{meeting.id}"
              class="font-semibold underline {meeting.quarter === 1
                ? 'text-red-700'
                : 'text-green-700'}">{meeting.link_text}</a
            >
          </span>
        </p>
      </div>
    </div>
  </div>
{/if}
